module.exports = __webpack_public_path__ + "img/NewDragCartIcon.30e96260.svg";